import { deDE, enUS } from '@mui/x-date-pickers/locales';

function normalizeLanguage(language) {
    if (!language || typeof language !== 'string') return 'en';
    return language.slice(0, 2).toLowerCase();
}

function getLocaleText(muiPickersLocale) {
    return muiPickersLocale?.components?.MuiLocalizationProvider?.defaultProps?.localeText;
}

export function getPickersLocale(language) {
    const lang = normalizeLanguage(language);

    if (lang === 'de') {
        return {
            adapterLocale: 'de',
            localeText: getLocaleText(deDE),
        };
    }

    return {
        adapterLocale: 'en',
        localeText: getLocaleText(enUS),
    };
}
